<template>
    <div class="gov-title">
        <div class="addTitle" v-if="setTitle != '查看'">
            <el-button type="primary" icon="el-icon-plus" size="mini" @click="handleAdd">新增</el-button>
        </div>
        <div class="infoServe">
            <el-table :data="tableData" border style="width: 100%; margin-top: 20px"
                :header-cell-style="{ background: '#f2f2f2', color: '#000' }">
                <el-table-column type="index" width="70" label="序号" align="center" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="equipmentTypeName" label="设备类型" align="center" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="equipmentBrandName" label="设备品牌" align="center" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="equipmentName" label="设备名称" align="center" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="equipmentNumber" label="设备号" align="center" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <span @click="toTip(scope.row.equipmentNumber)">{{ scope.row.equipmentNumber }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="equipmentAddress" label="设备位置" align="center" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column align="center" label='操作' v-if="setTitle != '查看'">
                    <template slot-scope="scope">
                        <button style="color: #2e99cf;" class="tabBtn"
                            @click="showDialogForm(scope.row, 'edit')">解绑</button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination class="pages" background layout="total, prev, pager, next"
                @current-change="handleCurrentChangeOne" :total="pageOne.total" :current-page.sync="pageOne.pageNo"
                :page-size="10">
            </el-pagination>
        </div>
        <!-- 添加或修改配置对话框 -->
        <el-dialog :title="title" :visible.sync="open" width="500px" append-to-body>
            <el-form ref="form" :model="form" :rules="rules" label-width="80px">
                <el-form-item label="设备类型" prop="equipmentId">
                    <el-select v-model="form.equipmentId" placeholder="请选择设备类型" style="width:100%"
                        :disabled="title == '查看设备'" @change="changeType">
                        <el-option v-for="item in typeList" :key="item.dictCode" :label="item.dictLabel"
                            :value="item.dictCode">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="设备号" prop="equipmentNumber">
                    <!-- <el-input v-model="form.equipmentNumber" type="text" placeholder="请输入" ></el-input> -->
                    <el-select v-model="form.equipmentNumber" placeholder="请选择设备类型" style="width:100%"
                        :disabled="title == '查看设备'">
                        <el-option v-for="item in brandList" :key="item.id" :label="item.equipmentNumber"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitForm">确 定</el-button>
                <el-button @click="cancel">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import request from "@/utils/request.js"
import exportVue from "@/utils/exportVue"
export default {
    props: {
        formData: {
            type: Object,
            default: () => ({
                id: ''
            })
        },

        serviceStation: {
            type: [String, Number],
            default: ''
        },
        setTitle: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            pageOne: { pageNo: 1, pageSize: 10, total: 0 },
            tableData: [],
            typeList: [],
            prodList: [],
            data: {},
            form: {
                equipmentId: '',
               equipmentNumber: null
            },
            open: false,
            title: '',
            addForm: { id: '' },
            brandList: [],
            rules: {
                equipmentId: [
                    { required: true, message: "设备类型不能为空", trigger: "blur" }
                ],
                equBrandId: [
                    { required: true, message: "设备品牌不能为空", trigger: "blur" }
                ],
                equNo: [
                    { required: true, message: "设备号不能为空", trigger: "blur" }
                ]
            }
        }
    },
    async created() {
        exportVue.$on("closeW", (data) => {
           this.tableData=[]
        })
        await this.getType()
    },
    watch: {
        formData: {
            handler(val) {
                this.addForm = val;
            },
            deep: true,
            immediate: true,
        },
         'formData.id': {
            handler(val) {
                this.tableData=[]
                this.customerId = val;
                this.getList()
            },
            deep: true,
            immediate: true,
        },
    },
    methods: {
        changeType(val) {
            this.brandList = []
           this.form.equipmentNumber = null  
            if (val) {
                this.getNumberList(val);
            }
        },
        toTip(equipmentNumber) {
            this.$router.push({
                path: "/deviceManage",
                query: {
                    equipmentNumber: equipmentNumber,
                },
            });
        },
        handleAdd() {
            this.open = true
            this.title = '新增设备'
        },
        showDialogForm(val, type) {
            this.$confirm("确认解绑?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.$http
                        .request({
                            url: "/ypt/admin/equipment/info/unBindEquipment",
                            method: "POST",
                            data: {
                                customerId: this.customerId,
                                equipmentId: val.id
                            },
                        })
                        .then((res) => {
                            if (res.code === 200) {
                                this.$message.success('解绑成功')
                                this.getList()
                            }
                        })
                })
                .catch(() => {
                })
        },
        // 设备类型
        getType() {
            let query = {
                pageNum: 1,
                pageSize: 999,
                dictType: "equipment_type",
            }
            this.$http
                .request({
                    url: "/rbac/system/dict/data/list",
                    method: "get",
                    params: query,
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.rows != null) {
                            this.typeList = res.rows
                        }
                    }
                })
        },
        getNumberList(Typeld) {
            this.$http
                .request({
                    url: "/ypt/admin/equipment/info/findList",
                    method: "post",
                    data: {
                        pageNo: 1,
                        pageSize: 9999,
                        bindFlag: 0,
                        equipmentTypeId: Typeld
                    },
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.content != null) {
                            res.content.list.forEach((item)=>{
                                item.id=String(item.id)
                            })
                             this.brandList=res.content.list
                        }
                    }
                })
        },
        getList() {
            if(!this.customerId){
                return false
            }
            this.$http
                .request({
                    url: "/ypt/admin/equipment/info/findList",
                    method: "post",
                    data: {
                        pageNo: this.pageOne.pageNo,
                        pageSize: this.pageOne.pageSize,
                        customerId: this.customerId
                    },
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.content && res.content != null) {
                            this.tableData = res.content.list
                            this.pageOne.total = res.content.count || 0
                        }else{
                            this.tableData =[]
                             this.pageOne.total =0
                        }
                    }
                })
        },
        submitForm: function () {
            let that = this
            this.$refs["form"].validate(valid => {
                if (valid) {
                    let url = ''
                    let infoS = ''
                    if (that.title == '新增设备') {
                        url = '/ypt/admin/equipment/info/bindEquipment'
                        infoS = '新增成功'
                    }
                    this.form.customerId = that.customerId
                    let obj = {
                        customerId: that.customerId,
                        equipmentId: Number(this.form.equipmentNumber)
                    }
                    this.$http
                        .request({
                            url: url,
                            method: 'post',
                            data: obj
                        })
                        .then((res) => {
                            if (res.code == 200) {
                                if (res.content == null || res.content == 'null') {
                                    this.msgSuccess(infoS);
                                }
                                this.open = false
                                this.form = {}
                                this.tableData = []
                                this.getList()
                            }
                        })
                }
            })
        },
        cancel() {
            this.open = false;
            this.form = {}
              this.tableData=[]
        },
        handleCurrentChangeOne() {
            this.pageOne.pageNo = val
        },
    },
}
</script>
<style lang="less" scoped>
.tabBtn {
    font-size: 13px;
    margin: 0 3px;
}

.gov-title {
    width: 98%;
    margin-left: 2%;
}

.pages {
    margin-top: 20px;
}

.addTitle {
    border-bottom: 1px solid #eee;
    padding: 10px 0;
    display: flex;
    line-height: 40px;

    .fontSize {
        font-weight: bold;
        color: #409eff;
        line-height: 40px;
        cursor: pointer;
    }
}

.infoServe {
    margin-top: 20px;

    .infoItem {
        display: flex;
        flex-wrap: wrap;

        .serveFlex {
            width: 25%;
            margin-bottom: 15px;

            .serveContent {
                padding: 0 15px;
                display: flex;

                // margin-bottom: 10px;
                .serveName {
                    width: 90px;
                    padding-right: 10px;
                    text-align: right;
                    color: #606266;
                    font-size: 14px;
                    line-height: 40px;
                }

                .serveSign {
                    flex: 1;
                }
            }
        }

        .delIcon {
            cursor: pointer;
            font-size: 20px;
            position: relative;
            top: 10px;
        }
    }
}

.entityServe {
    margin-top: 20px;
    border-top: 1px solid rgba(167, 164, 164, 0.8);
}

.right-title-6 {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    border-bottom: 1px solid #c0c4cc;
    border-left: 1px solid #c0c4cc;
    background-color: #eeeeee;
}

.rightTitle {
    width: 140px;
    // height: 100%;
    text-align: center;
    position: relative;

    p {
        position: absolute;
        width: 100%;
        left: 0;
        top: 47%;
    }
}

.rightBox {
    background: #fff;
    border-left: 1px solid #c0c4cc;
    flex: 1;
    padding: 10px;
    line-height: 30px;
}
</style>
